export default {
    title: "Home",
    button: {
        accessories: "Browse catalog"
    },
    noAvailableItems: "No products available to order.",
    error: "There was a problem retrieving products. Please refresh your browser."
}